import { render, staticRenderFns } from "./listacontrato.vue?vue&type=template&id=446220b7&"
import script from "./listacontrato.vue?vue&type=script&lang=js&"
export * from "./listacontrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports